__webpack_require__.p = "https://recette.satisfaction.grouperandstad.fr/";